import { render, staticRenderFns } from "./souurcingPublish.vue?vue&type=template&id=19c0bec1&scoped=true&"
import script from "./souurcingPublish.vue?vue&type=script&lang=js&"
export * from "./souurcingPublish.vue?vue&type=script&lang=js&"
import style0 from "./souurcingPublish.vue?vue&type=style&index=0&id=19c0bec1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0bec1",
  null
  
)

export default component.exports